import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";

export default function CallbackADPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log("Callback is handling code from AD")

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code'); 
        const stateReturned = urlParams.get('state');
        const stateExpected = sessionStorage.getItem('pkce_state');

        if (!code || stateReturned !== stateExpected) {
          console.error('Código faltante o state no coincide');
          navigate('/login?error=invalid_state');
          return;
        }

        const configResponse = await fetch('/configuration.json');
        
        if (!configResponse.ok) {
          console.error('Error al cargar configuration.json:', configResponse.status, configResponse.statusText);
          navigate('/login?error=config_load_failed');
          return;
        }
        
        const config = await configResponse.json();
        
        const { COGNITO_DOMAIN, COGNITO_APP_CLIENT_ID } = config;

        const tokenRequestBody = new URLSearchParams({
          grant_type: 'authorization_code',
          client_id: COGNITO_APP_CLIENT_ID,
          redirect_uri: `${window.location.origin}/callback-ad`,
          code: code,
          code_verifier: sessionStorage.getItem('pkce_verifier'),
        });

        const tokenResponse = await fetch(
          `https://${COGNITO_DOMAIN}/oauth2/token`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
            body: tokenRequestBody
          }
        );

        if (!tokenResponse.ok) {
          const errorText = await tokenResponse.text();
          console.error('Error en endpoint de token:', errorText);
          navigate('/login?error=token_exchange_failed');
          return;
        }

        const tokens = await tokenResponse.json();
        const { access_token, id_token, refresh_token } = tokens;

        const decodedToken = jwtDecode(access_token);
        const { username, exp } = decodedToken;
        const expirationDate = new Date(exp * 1000);

        const cookieOptions = {
          expires: expirationDate,
          secure: window.location.protocol === 'https:',
          sameSite: 'strict'
        };

        Cookies.set('accessToken', access_token, cookieOptions);
        Cookies.set('idToken', id_token, cookieOptions);
        Cookies.set('refreshToken', refresh_token, { 
          expires: 5,
          secure: window.location.protocol === 'https:',
          sameSite: 'strict'
        });
        Cookies.set('username', username, cookieOptions);
        Cookies.set('expirationDate', expirationDate.toISOString(), cookieOptions);

        sessionStorage.removeItem('pkce_state');
        sessionStorage.removeItem('pkce_verifier');

        navigate('/', { replace: true });

      } catch (error) {
        console.error('Error durante el callback de autenticación:', error);
        navigate('/login?error=callback_failed');
      }
    };

    handleCallback();
  }, [navigate]);

  return null;
}